<template>
    <div class="d-md-flex align-items-center justify-content-between gap-4 mt-2 mb-4">
        <div>
            <a class="text-dark" href="javascript:void(0)" @click="goBack()"><i
                class="ri-arrow-left-line fs-24"></i></a>
            <h3 v-if="update_status" style="display: inline;">Update Goonda Act / Externment / KCOCA Act</h3>
            <h3 v-else style="display: inline;">Add Goonda Act / Externment / KCOCA Act</h3>
        </div>
    </div>
    <div class="row g-3">
        <div class="col-xl-12">
            <div class="card">
                <div class="card-body">
                    <div class="card-body">
                        <h5 class="main-title fw-semibold mb-0">Rowdy Name: {{ rowdy.rowdy_sheeter_name }}</h5>
                        <hr>
                        <div class="tab-pane active" id="gangDetails">
                            <div class="row">
                                <div class="col-12">
                                    <div class="row g-3">
                                        <div class="col-4 mb-3">
                                            <label class="form-label">Type</label>
                                            <span class="text-danger"> *</span>
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'type')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <select class="form-control border-0 border-bottom form-select"
                                                :class="{ 'is-invalid': errors.type }" v-model="rowdy_goonda.type"
                                                @change="selectCaseType(rowdy_goonda.type)">
                                                <option value="">Select</option>
                                                <option value="Goonda">Goonda</option>
                                                <option value="Externment">Externment</option>
                                                <option value="KCOCA_Act">KCOCA Act</option>
                                            </select>
                                            <span v-if="errors.type" class="invalid-feedback">{{ errors.type[0]
                                                }}</span>
                                        </div>
                                        <div v-show="externment || goonda || kcoca_act" class="col-4 mb-3">
                                            <label class="form-label">Police Station</label>
                                            <span class="text-danger"> *</span>
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'police_station')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <search :class="{ 'is-invalid': errors?.police_station_id }"
                                                :customClass="{ 'is-invalid': errors?.police_station_id }"
                                                :initialize="police_station_id" id="police_station_id"
                                                label="police_station" placeholder="Select police station"
                                                :data="police_stations"
                                                @selected="police_station => police_station_id = police_station">
                                            </search>
                                            <span v-if="errors.police_station_id" class="invalid-feedback">{{
                                                errors.police_station_id[0] }}</span>
                                        </div>
                                        <div v-show="externment || goonda || kcoca_act" class="col-4 mb-3">
                                            <label class="form-label">Order No. and Date</label>
                                            <!-- <span class="text-danger"> *</span> -->
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'order_no')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <input type="text" class="form-control border-0 border-bottom"
                                                :class="{ 'is-invalid': errors.order_no }" v-model="rowdy_goonda.order_no"
                                                placeholder="Enter order no. and date..." />
                                            <span v-if="errors.order_no" class="invalid-feedback">{{ errors.order_no[0]
                                                }}</span>
                                        </div>
                                        <div v-show="externment || goonda"  class="mb-3"
                                            :class="{ 'col-4': rowdy_goonda.type == 'Goonda', 'col-6': (rowdy_goonda.type == 'Externment' || rowdy_goonda.type == '') }">
                                            <label class="form-label">Person Name</label>
                                            <!-- <span class="text-danger"> *</span> -->
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'person_name')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <input type="text" class="form-control border-0 border-bottom"
                                                :class="{ 'is-invalid': errors.person_name }"
                                                v-model="rowdy_goonda.person_name" placeholder="Enter person name..." />
                                            <span v-if="errors.person_name" class="invalid-feedback">{{
                                                errors.person_name[0] }}</span>
                                        </div>
                                        <div class="mb-3" v-show="externment || goonda"
                                            :class="{ 'col-4': rowdy_goonda.type == 'Goonda', 'col-6': (rowdy_goonda.type == 'Externment' || rowdy_goonda.type == '') }">
                                            <label class="form-label">Father Name</label>
                                            <!-- <span class="text-danger"> *</span> -->
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'father_name')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <input type="text" class="form-control border-0 border-bottom"
                                                :class="{ 'is-invalid': errors.father_name }"
                                                v-model="rowdy_goonda.father_name" placeholder="Enter father name..." />
                                            <span v-if="errors.father_name" class="invalid-feedback">{{
                                                errors.father_name[0] }}</span>
                                        </div>
                                        <div v-show="goonda" class="col-4 mb-3">
                                            <label class="form-label">Approved Status</label>
                                            <span class="text-danger"> *</span>
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'approved_status')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <select class="form-control border-0 border-bottom form-select"
                                                :class="{ 'is-invalid': errors.approved_status }"
                                                v-model="rowdy_goonda.approved_status">
                                                <option value="">Select</option>
                                                <option value="Approved">Approved</option>
                                                <option value="Rejected">Rejected</option>
                                            </select>
                                            <span v-if="errors.approved_status" class="invalid-feedback">{{
                                                errors.approved_status[0] }}</span>
                                        </div>
                                        <div v-show="externment || goonda" class="col-12 mb-3">
                                            <label class="form-label">Address</label>
                                            <!-- <span class="text-danger"> *</span> -->
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'address')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <textarea class="form-control border-0 border-bottom"
                                                :class="{ 'is-invalid': errors.address }" v-model="rowdy_goonda.address"
                                                placeholder="Enter address..." />
                                            <span v-if="errors.address" class="invalid-feedback">{{ errors.address[0]
                                                }}</span>
                                        </div>
                                        <div v-show="kcoca_act" class="col-4 mb-3">
                                            <label class="form-label">CR Number</label>
                                            <!-- <span class="text-danger"> *</span> -->
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'cr_number')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <input type="text" class="form-control border-0 border-bottom"
                                                :class="{ 'is-invalid': errors.cr_number }" v-model="rowdy_goonda.cr_number"
                                                placeholder="Enter CR number." />
                                            <span v-if="errors.cr_number" class="invalid-feedback">{{ errors.cr_number[0]
                                                }}</span>
                                        </div>
                                        <div v-show="kcoca_act" class="col-4 mb-3">
                                            <label class="form-label">Under Section</label>
                                            <!-- <span class="text-danger"> *</span> -->
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'under_section')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <input type="text" class="form-control border-0 border-bottom"
                                                :class="{ 'is-invalid': errors.under_section }" v-model="rowdy_goonda.under_section"
                                                placeholder="Enter Under which section." />
                                            <span v-if="errors.under_section" class="invalid-feedback">{{ errors.under_section[0]
                                                }}</span>
                                        </div>
                                        <div v-show="externment || goonda || kcoca_act" class="col-12 mb-3">
                                            <label class="form-label">Activities/Remarks</label>
                                            <!-- <span class="text-danger"> *</span> -->
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'activities')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <textarea class="form-control border-0 border-bottom"
                                                :class="{ 'is-invalid': errors.activities }"
                                                v-model="rowdy_goonda.activities" placeholder="Enter activities..." />
                                            <span v-if="errors.activities" class="invalid-feedback">{{
                                                errors.activities[0] }}</span>
                                        </div>
                                        <div v-show="externment" class="col-12 mb-3">
                                            <label class="form-label">To Which Place</label>
                                            <!-- <span class="text-danger"> *</span> -->
                                            &nbsp;<a v-if="update_status" href="javascript::void(0)"
                                                data-bs-toggle="modal" data-bs-target="#infoModal"
                                                @click="getGoondaEditHistory(rowdy_goonda.goonda_id,'which_place')"><i
                                                    class="ri-information-2-line"></i></a>
                                            <textarea class="form-control border-0 border-bottom"
                                                :class="{ 'is-invalid': errors.which_place }"
                                                v-model="rowdy_goonda.which_place" placeholder="Enter which place..." />
                                            <span v-if="errors.which_place" class="invalid-feedback">{{
                                                errors.which_place[0] }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button v-if="update_status" class="btn btn-primary float-end"
                                        @click="updateGoonda()">Update</button>
                                    <button v-else class="btn btn-primary float-end"
                                        @click="addGoonda()">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- History information modal -->
    <div class="modal fade bd-example-modal-md" tabindex="-1" id="infoModal">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Edited History</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
                    <div class="table-responsive small" style="overflow-y: scroll; height: 50vh;">
                        <table class="table table-sm table-bordered table-striped">
                            <thead>
                                <tr class="text-center">
                                    <th>#</th>
                                    <th>NEW {{ field_name.replace(/_/g, ' ') }}</th>
                                    <th>OLD {{ field_name.replace(/_/g, ' ') }}</th>
                                    <th>Edited By</th>
                                    <th>Date Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="field_history.length == 0">
                                    <td colspan="5" class="text-center">No Records to display!</td>
                                </tr>
                                <tr v-for="(edited, key) in field_history" :key="key" v-else>
                                    <td class="text-center">{{ key + 1 }}</td>
                                    <td>{{ edited.new_values[field_name] }}</td>
                                    <td>{{ edited.old_values[field_name] }}</td>
                                    <td>{{ edited.user.name }} : {{ edited.user.role?.role }}</td>
                                    <td>{{ edited.created_at }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>	
</template>
<script>
let Search = require("@/components/Search.vue").default;
export default {
    components: {
        Search
    },
    data() {
        return {
            police_station_id: '',
            rowdy_goonda: {
                goonda_id: '',
                rowdy_id: '',
                type: '',
                police_station_id: '',
                person_name: '',
                father_name: '',
                approved_status: '',
                which_place: '',
                address: '',
                cr_number: '',
                activities: '',
                order_no: ''
            },
            police_stations: [],
            errors: [],
            rowdy: {
                rowdy_sheeter_name: ''
            },
            update_status: false,
            edited_history: [],
            new_record: '',
            edited_field_name: '',
            nav_from: '',
            goonda: false,
            externment: false,
            kcoca_act: false,
            path:'',
            goonda_edit_histories: [],			
            field_history: [],
            field_name: '',
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.nav_from = from.name;
            if (to.name == 'RowdyGoondaUpdate') {
                vm.update_status = true;
                vm.getGoonda(to.params.goonda_id);
            }
            vm.rowdy_goonda.rowdy_id = to.params.rowdy_id;
            vm.getRowdy(to.params.rowdy_id);
            vm.getPoliceStations();
            vm.path = from.path;
        })
    },

    methods: {
        getPoliceStations() {
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'getPoliceStations' })
                .then(response => {
                    loader.hide();
                    this.police_stations = response.data.data;
                })
                .catch(error => {
                    loader.hide();
                    vm.errors = error.resposne.data.errors;
                    vm.$store.dispatch('error', error.response.data.message);
                })
        },

        getRowdy(rowdy_id) {
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'getRowdy', data: { rowdy_id: rowdy_id } })
                .then(response => {
                    loader.hide();
                    this.rowdy = response.data.data;
                })
                .catch(error => {
                    loader.hide();
                    vm.errors = error.resposne.data.errors;
                    vm.$store.dispatch('error', error.response.data.message);
                })
        },

        addGoonda() {
            let vm = this;
            this.rowdy_goonda.police_station_id = this.police_station_id;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'addGoonda', data: this.rowdy_goonda })
                .then(response => {
                    loader.hide();
                    this.$store.dispatch('success', response.data.message);
                    if(this.nav_from == 'UpdateCases'){
                        this.$router.push('/update_cases_processes/' + this.rowdy_goonda.rowdy_id);
                    } else {
                        this.$router.push('/update_cases_processes/' + this.rowdy_goonda.rowdy_id);
                    } 
                })
                .catch(error => {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch('error', error.response.data.message);
                })
        },

        updateGoonda() {
            let vm = this;
            this.rowdy_goonda.police_station_id = this.police_station_id;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'updateGoonda', data: this.rowdy_goonda })
                .then(response => {
                    loader.hide();
                    this.update_status = false;
                    this.$store.dispatch('success', response.data.message);
                    if(this.nav_from == 'UpdateCases'){
                        this.$router.push('/update_cases_processes/' + this.rowdy_goonda.rowdy_id);
                    } else {
                        this.$router.push('/view_rowdy/' + this.rowdy_goonda.rowdy_id);
                    } 
                })
                .catch(error => {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch('error', error.response.data.message);
                })
        },

        getGoonda(goonda_id) {
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'getGoonda', data: { goonda_id: goonda_id } })
                .then(response => {
                    loader.hide();
                    this.rowdy_goonda = response.data.data;
                    this.police_station_id = this.rowdy_goonda.police_station_id;
                    this.selectCaseType(this.rowdy_goonda.type);
                })
                .catch(error => {
                    loader.hide();
                    vm.errors = error.resposne.data.errors;
                    vm.$store.dispatch('error', error.response.data.message);
                })
        },

        getGoondaEditHistory(goonda_id, field_name) {
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'getGoondaEditHistory', data: { goonda_id: goonda_id } })
                .then(response => {
                    loader.hide();
                    this.goonda_edit_histories = response.data.data;
                    if(field_name == 'police_station'){
                        this.fieldHistoryPS(field_name);
                    } else {
                        this.fieldHistory(field_name);
                    }                                      
                })
                .catch(error => {
                    loader.hide()
                    vm.errors = error.response.data.errors
                })
        },

        fieldHistory(field_name) {
            this.field_name = field_name;
            this.field_history = this.goonda_edit_histories.filter(ele => {
                return Object.hasOwn(ele.old_values, field_name) || Object.hasOwn(ele.new_values, field_name)
            })
        },	

        fieldHistoryPS(field_name) {
            this.field_name = field_name;
            const ps_id = field_name+'_id';
            this.field_history = this.goonda_edit_histories.filter(ele => {
                return Object.hasOwn(ele.old_values, ps_id) || Object.hasOwn(ele.new_values, ps_id)
            })
            this.field_history.forEach(ele => {
                ele.new_values.police_station = this.police_stations.find(ps => ele.new_values.police_station_id == ps.police_station_id).police_station;
                ele.old_values.police_station = this.police_stations.find(ps => ele.old_values.police_station_id == ps.police_station_id).police_station;
            })
        },

        selectCaseType(type){
            this.goonda = false;
            this.externment = false;
            this.kcoca_act = false;
            switch (type) {
                case 'Goonda':
                    this.goonda = true;
                    break;
                case 'Externment':
                    this.externment = true;
                    break;
                case 'KCOCA_Act':
                    this.kcoca_act = true;
                    break;
            
                default:
                    break;
            }
        },

        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>